import { track } from "../tracking";

declare global {
  interface Window {
    Bridge: {
      // ?TODO used any because don't know what the return type is exactly
      navigate: (action: "replace" | "push", params: any) => void;
      isInBetaSchedule: () => Promise<boolean>;
      changeClinic: (clinicId: string) => void;
      track: (
        name: string,
        params?:
          | {
              [k: string]: string | undefined;
            }
          | undefined
      ) => void;
    };
  }
}

let bridge: Window["Bridge"];

let isBridgeAvailable = false;

export function initBridge() {
  try {
    // @ts-ignore
    bridge = new Bridge();
    isBridgeAvailable = true;
  } catch (e) {
    console.log("Bridge not available");
    isBridgeAvailable = false;
    // track("BRIDGE_GET_FAILURE", { error: (e as any).message });
  }

  return isBridgeAvailable;
}

function getBridges() {
  if (!isBridgeAvailable) {
    // retry
    initBridge();
  }
  return bridge;
}

export default getBridges;
